import { Moon, Sun } from "lucide-react";
import { useTheme } from "./ThemeProvider";

export function ThemeToggle({ className = "" }: { className?: string }) {
  const { theme, toggleTheme } = useTheme();
  const nextTheme = theme === "dark" ? "claro" : "escuro";

  return (
    <button
      aria-label={`Usar tema ${nextTheme}`}
      aria-pressed={theme === "light"}
      className={`theme-toggle ${className}`}
      onClick={toggleTheme}
      title={`Usar tema ${nextTheme}`}
      type="button"
    >
      {theme === "dark" ? <Sun aria-hidden="true" size={20} /> : <Moon aria-hidden="true" size={20} />}
    </button>
  );
}
